import { PermissionType, StaffPushSettingType } from 'types/staff'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { db } from 'firebase/index'
import { togglePushSettingsAction } from 'reducks/auth/actions'

const togglePushSettings = (permission: PermissionType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const push_settings: StaffPushSettingType[] = getState().auth.push_settings
    const isEventStaff = getState().auth.is_event_staff
    const manufacturerRef = getState().auth.manufacturer_ref
    const storeRef = getState().auth.store_ref
    const uid = getState().auth.uid

    const index = push_settings.findIndex((push_setting) => {
      if (
        // SSスタッフの場合
        isEventStaff &&
        typeof manufacturerRef === 'undefined'
      ) {
        return push_setting.store_ref.id === storeRef.id && typeof push_setting.manufacturer_ref === 'undefined'
      } else if (
        // SSモードの場合
        typeof manufacturerRef !== 'undefined'
      ) {
        return (
          push_setting.store_ref.id === storeRef.id &&
          typeof push_setting.manufacturer_ref !== 'undefined' &&
          push_setting.manufacturer_ref.id === manufacturerRef.id
        )
      } else {
        // 通常店舗の場合
        return push_setting.store_ref.id === storeRef.id
      }
    })

    if (!push_settings[index].manufacturer_ref) {
      push_settings[index] = {
        store_ref: push_settings[index].store_ref,
        permissions: push_settings[index].permissions.includes(permission)
          ? push_settings[index].permissions.filter((prevState) => prevState !== permission)
          : [...push_settings[index].permissions, permission],
      }
    } else {
      push_settings[index] = {
        store_ref: push_settings[index].store_ref,
        manufacturer_ref: push_settings[index].manufacturer_ref,
        permissions: push_settings[index].permissions.includes(permission)
          ? push_settings[index].permissions.filter((prevState) => prevState !== permission)
          : [...push_settings[index].permissions, permission],
      }
    }

    db.collection('staffs').doc(uid).update({ push_settings: push_settings })
    dispatch(togglePushSettingsAction(push_settings))
  }
}

export default togglePushSettings
